import { Colors } from 'src/components/theme'

type Props = {
  color?: string
}
export const LongDashDot = (props: Props) => {
  const { color } = props

  return (
    <svg width="40" height="3" viewBox="0 0 40 3" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.0703125" width="15" height="2" fill={color || Colors.blueDark} />
      <rect x="21" y="0.0703125" width="15" height="2" fill={color || Colors.blueDark} />
      <rect x="17" y="0.0703125" width="2" height="2" fill={color || Colors.blueDark} />
      <rect x="38" y="0.0703125" width="2" height="2" fill={color || Colors.blueDark} />
    </svg>
  )
}
